import React, {useState} from "react";
import {useTranslation} from "react-i18next";

//components:
import UploadDashboard from "./UploadDashboard";
import TrackSelector from "./TrackSelector";
import VideosUploadingTable from "./VideosUploadingTable";

const Upload = () => {
    const {t} = useTranslation();
    const [selectedTrack, setSelectedTrack] = useState();
    const [disableSelector, setDisableSelector] = useState(false);

    const trackIsSelected = () => selectedTrack && selectedTrack.name && selectedTrack.track_id;

    return (
        <div className="col-12 col-md-9">
            <div className="w-100 card card-custom gutter-b shadow">
                <div className="card-header flex-wrap pt-6 pb-0 border-bottom border-gray">
                    <div className="card-title">{t("ADMINPANEL.UPLOAD.TITLE")}</div>
                </div>
                <div className="card-body">
                    <h3>{t("ADMINPANEL.UPLOAD.TRACK_TARGET")}</h3>
                    <TrackSelector
                        t={t}
                        disabledTrackSelector={disableSelector}
                        selectedTrack={selectedTrack}
                        setSelectedTrack={setSelectedTrack}
                    />
                    {trackIsSelected() ? (
                        <div className="alert alert-secondary text-white">
                            {t("ADMINPANEL.UPLOAD.TRACK_SELECTED_I")}
                            {"  "}
                            <em className="font-weight-bolder">{selectedTrack.name}</em>
                            {"  "}
                            {t("ADMINPANEL.UPLOAD.TRACK_SELECTED_II")}
                        </div>
                    ) : null}
                    <h3>{t("ADMINPANEL.UPLOAD.FILE_UPLOAD")}</h3>
                    {trackIsSelected() ? (
                        <UploadDashboard selectedTrack={selectedTrack} setDisableSelector={setDisableSelector} />
                    ) : (
                        <div className="alert alert-light">{t("ADMINPANEL.UPLOAD.TRACK_NEEDED")}</div>
                    )}
                </div>
            </div>
            <VideosUploadingTable t={t} />
        </div>
    );
};

export default Upload;
